import React, { createContext, useContext, useMemo, useState, ReactNode } from 'react'

type DrawerKind = 'prod' | 'org'
type DrawerSel = { kind: DrawerKind; idx: number } | null

type DrawerCtx = {
  sel: DrawerSel
  open: boolean
  openDrawer: (sel: DrawerSel) => void
  closeDrawer: () => void
  select: (kind: DrawerKind, idx: number) => void
}

const Ctx = createContext<DrawerCtx | null>(null)

export function DrawerProvider({ children }: { children: ReactNode }) {
  const [sel, setSel] = useState<DrawerSel>(null)
  const value = useMemo<DrawerCtx>(
    () => ({
      sel,
      open: sel !== null,
      openDrawer: setSel,
      closeDrawer: () => setSel(null),
      select: (kind, idx) => setSel({ kind, idx }),
    }),
    [sel]
  )
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useDrawer() {
  const v = useContext(Ctx)
  if (!v) throw new Error('useDrawer must be used within DrawerProvider')
  return v
}
